var map = {
	"./Icon3D.png": "ebfa",
	"./IconApplication.png": "c71a",
	"./IconDesign.png": "272af",
	"./IconIllustration.png": "e2c9",
	"./IconPhotography.png": "cbdc",
	"./IconWeb.png": "5130"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1aa3";